import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import * as Sentry from "@sentry/react";
import App from "./App";
import "./global.css";

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_URL,
  integrations: [],
  environment: import.meta.env.VITE_ENVIRONMENT,
});

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
